import { render, staticRenderFns } from "./ReviewStars.vue?vue&type=template&id=105ad5e2&"
import script from "./ReviewStars.vue?vue&type=script&lang=js&"
export * from "./ReviewStars.vue?vue&type=script&lang=js&"
import style0 from "./ReviewStars.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {StarRatings: require('/opt/build/repo/storefront/components/atoms/Review/StarRatings.vue').default,BaseHeading: require('/opt/build/repo/storefront/components/atoms/Text/BaseHeading.vue').default,BaseCopy: require('/opt/build/repo/storefront/components/atoms/Text/BaseCopy.vue').default})
